import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import API from '../../api';
import { BASE_URL } from "../../config";
import { showSuccess } from "../../utils/dialog";
import "../../Styles/WHMIS.css";

// Modules list
const modules = [
  { id: "01", title: "Health and Safety Policy" },
  { id: "02", title: "Roles and Responsibilities" },
  { id: "03", title: "Workplace Harassment Policy" },
  { id: "04", title: "Workplace Violence Policy" },
  { id: "05", title: "Good Housekeeping Practices" },
  { id: "06", title: "Material Safety Data (MSDS)" },
  { id: "07", title: "Health & Safety Information" },
  {
    id: "08",
    title: "Workplace Hazardous Material Information System (WHMIS)",
  },
  { id: "09", title: "Health & Safety" },
  // ...Array.from({ length: 63 }, (_, i) => {
  //   const id = (i + 5).toString().padStart(2, "0"); // 05–67
  //   return { id, title: `WHMIS Program Page ${id}` };
  // }),
  // { id: "68", title: "WHMIS Quiz" },
];

// Helper to dynamically import WHMIS05–67 images
// const getWHMISImage = (id) => {
//   try {
//     return require(`../../assets/WHMIS${id}.png`);
//   } catch (err) {
//     console.warn(`Image WHMIS${id}.png not found`);
//     return null;
//   }
// };

// Base content for reading modules
const baseContent = {
  "01": (
    <div>
      <p>
        The Management of Talent Employment Inc. is vitally interested in the
        health and safety of its employees. Protection of employees from injury
        or occupational disease is a major continuing objective. Talent
        Employment Inc. will make every effort to provide a safe, healthy work
        environment.
      </p>
      <p>
        All supervisors and workers must be dedicated to the continuing
        objective of reducing risk of injury.
      </p>
      <p>
        Talent Employment Inc., as employer, is ultimately responsible for
        worker health and safety. As President of Talent Employment Inc., I give
        my personal promise that every reasonable precaution will be taken for
        the protection of workers.
      </p>
      <p>
        Supervisors will be held accountable for the health and safety of
        workers under their supervision. Supervisors are responsible to ensure
        that the facility and all equipment are safe and that workers work in
        compliance with established safe work practices and procedures. Workers
        must receive adequate training in their specific tasks to protect
        against health and safety.
      </p>
      <p>
        If adequate training is not being provided at any facility, Talent
        Employment Inc. requires that this issue be reported to Talent
        Employment Inc.’s Health and Safety Representative immediately.
      </p>
      <p>
        Every worker must protect his or her own health and safety by working in
        compliance with the law and with the safe work practices and procedures
        established by the company. Any contravention to these procedures must
        be reported immediately to Talent Employment Inc’s designated Health and
        Safety Representative.
      </p>
      <p>
        It is in the best interest of all parties to consider health and safety
        in every activity. Commitment to health and safety must form an integral
        part of Talent Employment Inc. from the president to the workers.
      </p>
    </div>
  ),
  "02": (
    // <div>
    //   <h1>
    //     <strong>W</strong>orkplace <strong>H</strong>azardous{" "}
    //     <strong>M</strong>aterial <strong>I</strong>nformation{" "}
    //     <strong>S</strong>ystem
    //   </h1>
    // </div>
    <div>
      <p>
        Under the Occupational Health & Safety Act (OHSA) workers and employers
        share responsibility for occupational health and safety. This concept of
        an internal responsibility system is based on the principle that
        workplace parties are in the best position to identify health and safety
        problems and to develop solutions.
      </p>
      <p style={{ marginTop: "30px" }}>
        Employers have the most responsibility for ensuring a safe and healthy
        workplace and must:
      </p>
      <ul className="form-bullets">
        <li>Keep a safe and well-maintained workplace</li>
        <li>
          Provide hazard information, proper safety equipment, training, and
          competent supervision.
        </li>
        <li>Have worker representation for the health and safety committee.</li>
        <li>Follow proper procedures in case of injury.</li>
      </ul>
      <p style={{ marginTop: "30px" }}>
        Supervisors have responsibility to provide:
      </p>
      <ul className="form-bullets">
        <li>A safe workplace and assign safe work.</li>
        <li>Training and information.</li>
        <li>Supervision.</li>
      </ul>
      <p style={{ marginTop: "30px" }}>Workers have the right to:</p>
      <ul className="form-bullets">
        <li>
          Know about any unsafe conditions or hazardous materials used in the
          workplace.
        </li>
        <li>Participate in making their work safe.</li>
        <li>Refuse unsafe work.</li>
      </ul>
      <p style={{ marginTop: "30px" }}>Workers also have responsibility to:</p>
      <ul className="form-bullets">
        <li>Work safely and not take risks.</li>
        <li>Report unsafe conditions.</li>
        <li>Wear the right safety equipment for the job.</li>
        <li>Ask their employers about concerns regarding health and safety.</li>
      </ul>
    </div>
  ),
  "03": (
    <div>
      <p>
        Talent Employment Inc. is committed to providing a work environment
        where all individuals are treated with dignity and respect. Individuals
        have the right to work in an environment free of any form of
        discrimination, including harassment, personal harassment, and bullying,
        and that respects the dignity, self-worth, and human rights of every
        individual.
      </p>
      <p>
        Harassment is defined under the Occupational Health and Safety Act as
        “engaging in a course of vexatious comment or conduct against a worker
        in a workplace, that is known or ought reasonable to be known to be
        unwelcome.” Harassment may also relate to a form of discrimination as
        defined under the Ontario Human Rights Code (race, ancestry, place of
        origin, color, ethnic origin, citizenship, creed, sex, sexual
        orientation, age, a record of offences, marital status, family status,
        or disability).
      </p>
      <p>
        Workplace harassment will not be tolerated by any person in the
        workplace. Workplace harassment may arise from a variety of sources
        including customers, contractors, employers, supervisors, colleagues,
        members of the public and domestic partners.
      </p>
      <p>
        The exercise of supervisory responsibilities, including training,
        performance appraisal, direction, instruction, counselling, and
        discipline does not constitute harassment if these are not being
        exercised in a harassing or intimidating manner.
      </p>
      <p>
        Talent Employment Inc. Workplace Harassment Program implements this
        policy. Workers are encouraged to report any incidents of workplace
        harassment by submitting a Violent Incident Report. Management will
        investigate and address all incidents of workplace harassment in a fair
        and timely manner while respecting workers’ privacy as much as possible.
      </p>
      <p style={{ marginTop: "30px", fontWeight: "bold" }}>Responsibilities</p>
      <ul className="form-bullets">
        <li>
          The Talent Employment Inc. management team is committed to ensuring
          that every employee has the right to work in a harassment-free
          workplace. The management team is concerned about the quality of work
          life’ and in keeping with the spirit of the Human Rights Code and its
          legal and social responsibilities as an employer, Talent Employment
          Inc. management will treat a complaint of harassment as a serious
          matter to be dealt with effectively and treated with sensitivity,
          discretion, and confidentiality.
        </li>
      </ul>
      <p style={{ marginTop: "30px", fontWeight: "bold" }}>
        Management Responsibilities
      </p>
      <ul className="form-bullets">
        <li>
          Proactively provide a positive workplace where human rights are
          respected, and employees are afforded equal opportunities with zero
          tolerance toward harassment and discrimination.
        </li>
        <li>
          Have a clear and effective Workplace Harassment Policy and Program.
        </li>
        <li>
          Ensure the policy and program are reviewed as often as is necessary.
        </li>
        <li>
          Communicated and review the policy and program with employees they
          supervise or manage.
        </li>
        <li>Refrain from any form of harassment or discrimination.</li>
        <li>
          Understand and abide by the requirements of the Workplace Harassment
          Policy and its program.
        </li>
        <li>
          Ensure a copy of the policy is posted in a conspicuous place in the
          workplace.
        </li>
        <li>
          Provide and participate in the information and instruction sessions
          for employees related to workplace harassment.
        </li>
        <li>
          Encourage employees to report complaints or incidents of workplace
          harassment.
        </li>
        <li>
          Promptly report all complaints or incidents of workplace harassment to
          their superiors and seek their resolution.
        </li>
        <li>
          Respond to, address, and investigate complaints or incidents of
          workplace harassment in a professional manner appropriate for the
          circumstances of the complaint or incident in accordance with the
          Workplace Harassment program.
        </li>
        <li>Document all complaints or incidents of workplace harassment.</li>
        <li>
          Advise employees of their right to file a complaint under the Human
          Rights Code.
        </li>
        <li>Monitor the outcome of complaints.</li>
        <li>
          Provide employees who have been subjected to workplace harassment and
          their co-workers who witnessed the incident (s) with appropriate
          support.
        </li>
      </ul>
      <p style={{ marginTop: "30px", fontWeight: "bold" }}>
        Employee Responsibilities
      </p>
      <ul className="form-bullets">
        <li>
          Refrain from any form of harassment or discrimination. A co-worker who
          infringes the right of another employee can be named as a personal
          respondent in a complaint.
        </li>
        <li>
          Always comply with the Workplace Harassment Policy and Program to
          protect themselves and others in the workplace from workplace
          harassment.
        </li>
        <li>
          Take part, in good faith, in training and educational activities
          related to workplace harassment prevention.
        </li>
        <li>
          Report immediately all incidents of workplace harassment experienced,
          witnessed, or having the knowledge to their supervisor or any other
          member of management without fear of reprisal or retaliation.
        </li>
        <li>
          Cooperate fully in the investigation of complaints or incidents of
          workplace harassment.
        </li>
      </ul>
    </div>
  ),
  "04": (
    <div>
      <p>
        Talent Employment Inc. is committed to providing a safe and healthy
        workplace free from actual, attempted, or threatened violence in
        compliance with Occupational Health and Safety Act requirements.
        Management will take all reasonable precautions to prevent workplace
        violence and to protect employees at the workplace.
      </p>
      <p style={{ marginTop: "30px" }}>
        Workplace violence is defined under the Occupational Health and Safety
        Act as:
      </p>
      <ul className="form-bullets">
        <li>
          The Talent Employment Inc. management team is committed to ensuring
          that every employee has the right to work in a harassment-free
          workplace. The management team is concerned about the quality of work
          life’ and in keeping with the spirit of the Human Rights Code and its
          legal and social responsibilities as an employer, Talent Employment
          Inc. management will treat a complaint of harassment as a serious
          matter to be dealt with effectively and treated with sensitivity,
          discretion, and confidentiality.
        </li>
        <li>
          an attempt to exercise physical force against a worker, in a
          workplace, that could cause physical injury to the worker; or
        </li>
        <li>
          a statement or behavior that is reasonable for a worker to interpret
          as a threat to exercise physical force against the worker, in a
          workplace, that could cause physical injury to the worker.
        </li>
      </ul>
      <p style={{ marginTop: "30px" }}>
        Violent behavior in the workplace is unacceptable from anyone. Workplace
        violence may arise from a variety of source including customers,
        contractors, employers, supervisors, workers, members of the public, and
        domestic partners. Everyone is expected to uphold this policy and work
        together to prevent workplace violence.
      </p>
      <p>
        There is a workplace violence program that implements this policy. It
        includes measures and procedures to protect workers from workplace
        violence, a means of summoning immediate assistance and a process for
        workers to report incidents or raise concerns. All employees will adhere
        to this policy and the supporting program. Everyone is encouraged to
        raise any concerns about workplace violence and to report any violent
        incidents or threats.
      </p>
      <p>
        Concerns should be entered into a Violent Incident Report. Management
        will investigate and address all incidents of workplace violence in a
        timely and fair manner, respecting the privacy of all concerned as much
        as possible.
      </p>
      <p>
        Talent Employment Inc., as the employer, will ensure that this policy
        and the supporting program are implemented and maintained and that all
        employees and supervisors have the appropriate information and
        instruction to protect them from violence in the workplace.
      </p>
      <p style={{ marginTop: "30px", fontWeight: "bold" }}>
        Management Responsibilities
      </p>
      <ul className="form-bullets">
        <li>
          Proactively provide a positive workplace with zero tolerance towards
          violence in the workplace
        </li>
        <li>Have a clear and effective Workplace Violence Policy</li>
        <li>
          Ensure the policy and program are implemented and reviewed as often as
          is necessary.
        </li>
        <li>Treat all persons with respect and dignity.</li>
        <li>
          Understand and abide by the requirements of the Workplace Violence
          Policy and its program.
        </li>
        <li>
          Communicate and review the policy and program with the employees they
          supervise or manage.
        </li>
        <li>
          Ensure a copy of the policy is posted in a conspicuous place in the
          workplace.
        </li>
        <li>
          Provide and participate in information and instruction sessions for
          employees related to workplace violence.
        </li>
        <li>
          Provide information, including personal information, related to a risk
          of workplace violence from a person with a history of violent
          behavior, if the (a) employee can be expected to encounter that person
          during his or her work and (b) risk of violence is likely to expose
          the worker to physical injury. Disclosure of information is limited to
          no more than is necessary to protect the worker from physical injury.
        </li>
        <li>
          Encourage employees to report complaints or incidents of workplace
          violence.
        </li>
        <li>
          Approach an employee if violence or the threat of violence is
          suspected because some employees may be embarrassed, reluctant, or
          otherwise unable to report a violent incident or threat of violence.
        </li>
        <li>
          Notify the police, as warranted, depending on the nature of the actual
          or potential violent incident.
        </li>
        <li>
          Promptly report all complaints or incidents of workplace violence to
          their superior and seek their resolution.
        </li>
        <li>
          Respond, address, and investigate complaints or incidents of workplace
          violence in a professional and timely manner appropriate for the
          circumstances of the complaint or incident in accordance with the
          Workplace Violence program.
        </li>
        <li>
          Provide employees who have been subjected to workplace violence and
          their coworkers who witnessed the incident(s) with appropriate
          supports.
        </li>
        <li>
          Collaborate with the JHSC in conducting workplace violence risk
          assessments and reassessments after a reported complaint or incidence
          of violence.
        </li>
        <li>
          Develop and implement measures and procedures to address the workplace
          violence risks identified in the risk assessment.
        </li>
        <li>
          Notify the HSC when measures and procedures identified in the risk
          assessment have been implemented.
        </li>
        <li>
          Review the Workplace Violence Policy and Program as often as is
          necessary.
        </li>
        <li>
          Serve as workplace coordinator with respect to workplace violence for
          their respective department and ensure that all requirements of the
          Workplace Violence Policy are implemented in their department.
        </li>
      </ul>
      <p style={{ marginTop: "30px", fontWeight: "bold" }}>
        Health and Safety Committee Responsibilities
      </p>
      <ul className="form-bullets">
        <li>
          Assess the risks of workplace violence, as often as is necessary, but
          always within 30 days after a reported complaint or incidence of
          violence.
        </li>
        <li>
          Identify measures and procedures to control the risks identified in
          the assessment and provide these to managers in writing.
        </li>
        <li>
          Provide the measures and procedures identified to control risks
          created due to a reassessment following an incidence of workplace
          violence to the incident investigator within 30 days of the incident.
        </li>
        <li>
          Promote the principles of the Workplace Violence Policy to the
          employees.
        </li>
      </ul>
      <p style={{ marginTop: "30px", fontWeight: "bold" }}>
        Employee Responsibilities
      </p>
      <ul className="form-bullets">
        <li>Refrain from any form of violence!</li>
        <li>
          Be aware and always comply with the Workplace Violence Policy and
          Program to protect themselves and others in the workplace from
          workplace violence.
        </li>
        <li>
          Take part, in good faith, in training and educational activities
          related to workplace violence risks in the workplace.
        </li>
        <li>
          Report immediately all incidents of workplace violence that occur or
          are likely to occur to their supervisor or any other member of
          management without fear of reprisal or retaliation.
        </li>
        <li>
          In the case of extreme or imminent threat or physical harm to
          themselves or any person from workplace violence, contact the Police
          immediately.
        </li>
        <li>
          Cooperate fully in the investigation of complaints or incidents of
          workplace violence.
        </li>
      </ul>
      <p
        style={{
          marginTop: "30px",
          fontWeight: "bold",
          textDecoration: "underline",
        }}
      >
        PROCEDURE:
      </p>
      <ul className="form-bullets">
        <li>
          All employees have a duty to report workplace safety issues, including
          workplace violence to their Manager or the Owner. All complaints or
          incidents are to be recorded on the Violent Incident Report Form.
        </li>
        <li>
          Any person subjected to workplace violence should, where appropriate,
          go to a safe place in the workplace and report the incident to their
          supervisor or any member of the Management Team so that the incident
          can be investigated and addressed. In the case of extreme or imminent
          threat or physical harm to a n employee or any person from workplace
          violence, the Police should be contacted immediately.
        </li>
      </ul>

      <p style={{ marginTop: "30px", fontWeight: "bold" }}>
        Complaint Responsibilities
      </p>
      <ul className="form-bullets">
        <li>
          Explain to the person who is harassing them that the conduct is
          unwelcome. If addressing the person responsible could lead to an
          escalation of harassment, or to safety risks, the complainant is not
          expected to have to directly interact with that person. If a
          complainant feels that they can safely make it known to the person
          responsible that the behavior is unwelcome, this may resolve the
          matter, or may assist them later if they make a compliant
        </li>
        <li>
          Seek assistance from a manager or senior manager (as appropriate_ if
          the situation cannot be resolved by speaking to the person responsible
          for the harassment
        </li>
        <li>
          Provide a written complaint (using the Violent Incident Report) to
          their manager (as appropriate) including details of:
        </li>
        <li>What happened.</li>
        <li>When it happened.</li>
        <li>Where it happened.</li>
        <li>Who saw it happen.</li>
      </ul>

      <p style={{ marginTop: "30px", fontWeight: "bold" }}>Remedial Action</p>
      <p>
        The complainant and respondent shall each be provided with a copy of the
        investigator’s report and the decision regarding outcomes.
      </p>
      <p>
        If there is no satisfactory evidence of harassment, no record of the
        complaint will be kept on any person’s file.
      </p>
      <p style={{ marginTop: "30px", fontWeight: "bold" }}>Reprisal</p>
      <p>
        No form of reprisal, whether actual or threatened, against a person who
        initiates or contemplates initiating a complaint of workplace harassment
        will be tolerated. An employee who participates or is involved in a
        reprisal, whether actual or threatened, may be subject to disciplinary
        action up to and including possible termination of employment.
      </p>
      <p style={{ marginTop: "30px", fontWeight: "bold" }}>
        Employee’s Rights of Redress
      </p>
      <p>
        The provisions of this policy and program in no way affect the right of
        any person to exercise his or her rights under the Ontario Human Rights
        Code, the Workplace Violence policy and program, or other legal action.
      </p>
    </div>
  ),
  "05": (
    <div>
      <p>
        Housekeeping is not just cleanliness. It includes keeping work areas
        neat and orderly; maintaining halls and floors free of slip and trip
        hazards; and removing of waste materials (e.g., paper, cardboard) and
        other fire hazards from work areas.
      </p>
      <p>
        Effective housekeeping can eliminate some workplace hazards and help get
        a job done safely and properly. Poor housekeeping can frequently
        contribute to accidents by hiding hazards that cause injuries.
      </p>
      <p style={{ marginTop: "30px", fontWeight: "bold" }}>
        What are some signs of poor housekeeping?
      </p>
      <ul className="form-bullets">
        <li>cluttered and poorly arranged work areas;</li>
        <li>
          untidy or dangerous storage of materials (for example, materials
          stuffed in corners overcrowded shelves);
        </li>
        <li>dusty, dirty floors and work surfaces;</li>
        <li>items that are in excess or no longer needed;</li>
        <li>blocked or cluttered aisles and exits;</li>
        <li>
          tools and equipment left in work areas instead of being returned to
          roper storage places;
        </li>
        <li>broken containers and damaged materials;</li>
        <li>overflowing waste bins and containers;</li>
        <li>spills and leaks.</li>
      </ul>
      <p style={{ marginTop: "30px", fontWeight: "bold" }}>
        General Housekeeping Pointers{" "}
      </p>
      <p>
        Whether your workplace is an office, plant, store, or warehouse, here
        are some recommended housekeeping practices:
      </p>
      <ul className="form-bullets">
        <li>Follow safe work procedures and the requirements of the law.</li>
        <li>Keep work areas clean.</li>
        <li>Keep aisles clear.</li>
        <li>Keep exits and entrances clear.</li>
        <li>Stack and store items safety.</li>
        <li>Use proper waste containers.</li>
        <li>Report spills and leaks of any type promptly to a supervisor.</li>
        <li>Clean and store tools, items, and equipment properly.</li>
        <li>Report broken or damaged tools and equipment to a supervisor.</li>
      </ul>
    </div>
  ),
  "06": (
    <div>
      <p style={{ marginTop: "30px", fontWeight: "bold" }}>
        What is a Material Safety Data Sheet (MSDS)?
      </p>
      <p>
        A Material Safety Data Sheet (MSDS) is a document that contains
        information on the potential hazards (health, fire, reactivity and
        environmental) and how to work safely with the chemical product. It is
        an essential starting point for the development of a complete health and
        safety program. It also contains information on the use, storage,
        handling, and emergency procedures all related to the hazards of the
        material. The MSDS contains much more information about the material
        than the label. MSDSs are prepared by the supplier or manufacturer of
        the material. It is intended to tell what the hazards of the product
        are, how to use the product safely, what to expect if the
        recommendations are not followed, what to do if accidents occur, how to
        recognize symptoms of overexposure, and what to do if such incidents
        occur.
      </p>
      <p style={{ marginTop: "30px", fontWeight: "bold" }}>
        What information is on the MSDS?{" "}
      </p>
      <p>
        There are nine (9) categories of information that must be present on an
        MSDS in Canada. These categories are specified in the Controlled
        Products Regulations and include:
      </p>
      <ol
        className="form-bullets"
        style={{ listStyleType: "decimal", paddingLeft: "25px" }}
      >
        <li>
          Product Information: product identifier (name), manufacturer and
          suppliers’ names, addresses, and emergency phone numbers
        </li>
        <li>Hazardous Ingredients</li>
        <li>Physical Data</li>
        <li>Fire or Explosion Hazard Data</li>
        <li>
          Reactivity Data: information on the chemical instability of a product
          and the substances it may react with
        </li>
        <li>Toxicological Properties: health effects</li>
        <li>Preventive Measures</li>
        <li>First Aid Measures</li>
        <li>
          Preparation Information: who is responsible for preparation and date
          of preparation of MSDS.
        </li>
      </ol>
      <p style={{ marginTop: "30px", fontWeight: "bold" }}>
        When would I use an MSDS?
      </p>
      <p>
        Always be familiar with the hazards of a product BEFORE you start using
        it. You should look at a MSDS, match the name of the chemical on your
        container to the one on the MSDS, know the hazards, understand safe
        handling and storage instructions, as well as understand what to do in
        an emergency.
      </p>
      <p style={{ marginTop: "30px", fontWeight: "bold" }}>Workplace Label </p>
      <ul className="form-bullets">
        <li>Name of Product</li>
        <li>Safe handling for product</li>
        <li>Reference to MSDS</li>
      </ul>
      <img
        src={require("../../assets/MSDS01.png")}
        alt="MSDS Example"
        style={{ width: "350px", marginTop: "20px" }}
      />
      <p style={{ marginTop: "30px", fontWeight: "bold" }}>
        Material Safety Data Sheets (MSDS){" "}
      </p>
      <ul className="form-bullets">
        <li>Product Information</li>
        <li>Hazardous Ingredients</li>
        <li>Physical Data</li>
        <li>Fire and Explosion Data</li>
        <li>Reactivity Data</li>
        <li>Toxicological Properties</li>
        <li>Preventative Measures</li>
        <li>First Aid Measure</li>
        <li>Preparation Information</li>
      </ul>
      <img
        src={require("../../assets/MSDS02.png")}
        alt="MSDS Example"
        style={{ width: "400px", marginTop: "20px" }}
      />
      <p style={{ marginTop: "30px", fontWeight: "bold" }}>Supplier Label </p>
      <ul className="form-bullets">
        <li>Name of Product</li>
        <li>Name of the Company</li>
        <li>Reference to MSDS</li>
        <li>Hazard symbol(s)</li>
        <li>Risk phrases.</li>
        <li>Precautionary measures</li>
        <li>First aid measures</li>
        <li>Text in English and French</li>
        <li>Distinctive WHMIS border</li>
      </ul>
      <img
        src={require("../../assets/MSDS03.png")}
        alt="MSDS Example"
        style={{ width: "400px", marginTop: "20px" }}
      />
    </div>
  ),
  "07": (
    <div>
      <p>
        The health and safety of our employees is extremely important to Talent
        Employment Inc. All of Talent’s clients are expected to provide
        site-specific training to Talent Employment Inc. employees. If you do
        not receive adequate training, please report this to Talent Employment
        Inc.’s designated Health and Safety Representative immediately.
      </p>
      <p>
        In addition to site-specific training provided by the facility, Talent
        Employment Inc. expects that all employees understand and adhere to the
        following safety requirements:
      </p>
      <ul className="form-bullets">
        <li>
          Do not operate any piece of equipment or forklift truck unless
          properly trained and assigned by your immediate supervisor.
        </li>
        <li>Machine tools must be attended while they are in operation.</li>
        <li>
          All flammable liquids and acids must be kept in safe containers and
          properly identified.
        </li>
        <li>Wear approved safety equipment/apparel as directed.</li>
        <li>Obey all rules, signs, and instructions.</li>
        <li>
          Always use proper lifting techniques when manual material handling is
          required.
        </li>
        <li>Stand close to the object you are going to lift.</li>
        <li>Place your feet shoulder-width apart.</li>
        <li>
          Bend your knees and keep your back straight to squat to the level of
          the object.
        </li>
        <li>Test the weight of the load before lifting.</li>
        <li>Keep the load close to your body.</li>
        <li>
          Use the strength of your leg and arm muscles (not your back) to lift
          the load smoothly and slowly.
        </li>
        <li>Pivot to turn in the direction you want to move toward.</li>
        <li>Avoid twisting your body while turning and carrying the load.</li>
        <li>Bend your knees and slowly lower the load to its new location.</li>
        <li>
          Always ask for help if the load is too large, heavy, or awkward.
        </li>
      </ul>
      <p style={{ marginTop: "30px" }}>
        Employees are required to report any condition or practice which may
        pose a risk to people, equipment, property materials or the facility
        immediately to your on-site supervisor and your Talent Employment Inc.
        health and safety representative.
      </p>
      <p style={{ marginTop: "30px", fontWeight: "bold" }}>
        *FOR MORE INFORMATION ON HEALTH AND SAFETY ROLES, RESPONSIBILITIES AND
        POLICIES, PLEASE REVIEW THE HEALTH AND SAFETY BOOK AVAILABLE AT
        RECEPTION*
      </p>
    </div>
  ),
  "08": (
    <div>
      <p>
        The goal of WHMIS is to reduce the occurrence of injury and illness
        caused by hazardous materials in the workplace by providing information
        on the safe handling and use of hazardous materials.
      </p>
      <p>
        All employees must be properly trained when working with controlled
        products.
      </p>
      <p>
        Employers, management, and employees must all have access to Material
        Safety Data Sheets
      </p>
      <p>All controlled products will have the following:</p>
      <ul className="form-bullets">
        <li>Classifications</li>
        <li>Labelling</li>
        <li>Material safety data sheets</li>
      </ul>
      <p style={{ marginTop: "30px", fontWeight: "bold" }}>
        Controlled Product Classifications:
      </p>
      <img
        src={require("../../assets/WHMIS68.png")}
        alt="MSDS Example"
        style={{ width: "650px", marginTop: "20px" }}
      />
      <p style={{ marginTop: "30px", fontWeight: "bold" }}>Supplier Label</p>
      <ul className="form-bullets">
        <li style={{ fontWeight: "bold" }}>Name of Product</li>
        <li style={{ fontWeight: "bold" }}>Name of the Company</li>
        <li style={{ fontWeight: "bold" }}>Reference to MSDS</li>
        <li style={{ fontWeight: "bold" }}>Hazard symbol(s)</li>
        <li style={{ fontWeight: "bold" }}>Risk phrases</li>
        <li style={{ fontWeight: "bold" }}>Precautionary measures</li>
        <li style={{ fontWeight: "bold" }}>First aid measures</li>
        <li style={{ fontWeight: "bold" }}>Text in English and French</li>
        <li style={{ fontWeight: "bold" }}>Distinctive WHMIS border</li>
      </ul>
      <img
        src={require("../../assets/MSDS03.png")}
        alt="MSDS Example"
        style={{ width: "400px", marginTop: "20px" }}
      />
      <p style={{ marginTop: "30px", fontWeight: "bold" }}>Work Place Label </p>
      <ul className="form-bullets">
        <li style={{ fontWeight: "bold" }}>Name of Product</li>
        <li style={{ fontWeight: "bold" }}>Safe handling for product</li>
        <li style={{ fontWeight: "bold" }}>Reference to MSDS</li>
      </ul>
      <img
        src={require("../../assets/MSDS01.png")}
        alt="MSDS Example"
        style={{ width: "350px", marginTop: "20px" }}
      />
      <p style={{ marginTop: "30px", fontWeight: "bold" }}>
        Material Safety Data Sheets (MSDS)
      </p>
      <ul className="form-bullets">
        <li style={{ fontWeight: "bold" }}>Product Information</li>
        <li style={{ fontWeight: "bold" }}>Hazardous Ingredients</li>
        <li style={{ fontWeight: "bold" }}>Physical Data</li>
        <li style={{ fontWeight: "bold" }}>Fire and Explosion Data</li>
        <li style={{ fontWeight: "bold" }}>Reactivity Data</li>
        <li style={{ fontWeight: "bold" }}>Toxicological Properties</li>
        <li style={{ fontWeight: "bold" }}>Preventative Measures</li>
        <li style={{ fontWeight: "bold" }}>First Aid Measure</li>
        <li style={{ fontWeight: "bold" }}>Preparation Information</li>
      </ul>
      <img
        src={require("../../assets/MSDS02.png")}
        alt="MSDS Example"
        style={{ width: "400px", marginTop: "20px" }}
      />
    </div>
  ),
  "09": (
    <div className="sds-content">
      <p style={{ marginTop: "30px" }}>
        Please complete the Health and Safety Questionnaire{" "}
      </p>
    </div>
  ),
};

// // For 05–67, generate dynamically
// for (let i = 5; i <= 67; i++) {
//   const id = i.toString().padStart(2, "0");
//   baseContent[id] = (
//     <div className="sds-content">
//       <img src={getWHMISImage(id)} alt={`WHMIS Example ${id}`} className="sds-image" />
//     </div>
//   );
// }

// Quiz questions for module 68
const quizQuestions = [
  {
    question:
      "1. It is important to know the safe way to do your job. You should share what you know. If you see a hazard, you must report it right away",
    options: ["yes", "No", "Maybe", "Somewhat"],
    answer: 0,
  },
  {
    question:
      "2. It is against the law for your employer or supervisor to fire or punish you for doing what the OSHA expects you top do, r for asking them to do what the OSHA asks them to do.",
    options: ["Yes", "No"],
    answer: 0,
  },
  {
    question:
      "3. Some workers such as nurses, firefighters, and police officers, have a limited right to refuse work.",
    options: ["Yes", "No"],
    answer: 0,
  },
  {
    question:
      "4. If you have reason to believe the equipment that you are using might hurt you or someone you work with, you have the legal right to refuse to work.",
    options: ["Yes", "No"],
    answer: 0,
  },
  {
    question:
      "5. If you report a dangerous situation to your supervisor and your health and safety representative and they can't find a way to fix it you can call the Ministry of Labour's toll-free number for help.",
    options: ["Yes", "No"],
    answer: 0,
  },
  {
    question:
      "6. It is ok to take safety shortcuts to get work done faster and on time",
    options: ["Yes", "No"],
    answer: 1,
  },
  {
    question:
      "7. Your health and safety representative or joint health and safety committee can help you with any concerns that you might have about working safely.",
    options: ["Yes", "No"],
    answer: 0,
  },
  {
    question:
      "8. If you can't find any health and safety information posted in your workplace you should just go back to work and not worry about it.",
    options: ["Yes", "No"],
    answer: 1,
  },
  {
    question:
      "9. You should get involved in health and safety by asking questions, and you should put what you have learned in training into practice on the job.",
    options: ["Yes", "No"],
    answer: 0,
  },
  {
    question:
      "10. The number of people in Ontario who suffer a work related illness or injury each year would fill the seats of a dozen large hockey arenas.",
    options: ["Yes", "No"],
    answer: 0,
  },
  {
    question:
      "11. If you see a hazard while you're working, you should report it to your supervisor or employer right away.",
    options: ["Yes", "No"],
    answer: 0,
  },
  {
    question:
      "12. If you have any doubts about thye safety of the work you're doing, you should keep those doubts to yourself.",
    options: ["Yes", "No"],
    answer: 1,
  },
  {
    question:
      "13. To keep from getting hurt on the job, you need to find out about hazards while you are working.",
    options: ["Yes", "No"],
    answer: 1,
  },
  {
    question:
      "14. If a hazard can make you sick, you will always start to feel sick right away.",
    options: ["Yes", "No"],
    answer: 1,
  },
  {
    question:
      "15. The Occupational Health and Safety Act says that you have the right to know about hazards in your workplace.",
    options: ["Yes", "No"],
    answer: 0,
  },
  {
    question:
      "16. The OSHA puts the greatest responsibility on the employer to fire or punish me for doing what the OSHA says",
    options: ["Yes", "No"],
    answer: 1,
  },
  {
    question:
      "17. The occupational Health and Safety Act and Regulations tell everyone from the employer to the newest worker how to make the workplace safer?",
    options: ["Yes", "No"],
    answer: 0,
  },
  {
    question:
      "18. New workers are less likely to get hurt on the job than the people who have been on the job longer.",
    options: ["Yes", "No"],
    answer: 1,
  },
];

export default function TrainingInterface() {
  const navigate = useNavigate();
  const accountId = localStorage.getItem("accountId");
  const itemId = "health-safety";
  
  // ✅ FIX: Initialize from localStorage ONLY if quiz was actually completed
  const [unlockedModules, setUnlockedModules] = useState(() => {
    // Check if quiz was actually completed
    const savedStatus = localStorage.getItem(`status_${accountId}_health-safety`);
    const isActuallyComplete = savedStatus === "complete";
    
    if (isActuallyComplete) {
      const saved = localStorage.getItem("healthsafety_unlockedModules");
      if (saved) {
        try {
          const parsed = JSON.parse(saved);
          if (Array.isArray(parsed) && parsed.length > 0) {
            return Array.from(new Set(["01", ...parsed]));
          }
        } catch (e) {
          return ["01"];
        }
      }
    }
    
    // If not complete, start with only first module unlocked
    return ["01"];
  });
  
  // ✅ FIX: Only load saved current module if quiz was actually completed
  const [currentModule, setCurrentModule] = useState(() => {
    const savedStatus = localStorage.getItem(`status_${accountId}_health-safety`);
    const isActuallyComplete = savedStatus === "complete";
    
    if (isActuallyComplete) {
      const saved = localStorage.getItem("healthsafety_currentModule");
      return saved ? saved : "01";
    }
    
    return "01";
  });

  // quiz
  const [quizStarted, setQuizStarted] = useState(false);
  
  // ✅ FIX: Only load saved quiz index if quiz was actually completed
  const [quizIndex, setQuizIndex] = useState(() => {
    const savedStatus = localStorage.getItem(`status_${accountId}_health-safety`);
    const isActuallyComplete = savedStatus === "complete";
    
    if (isActuallyComplete) {
      const saved = localStorage.getItem("healthsafety_quizIndex");
      return saved ? Number(saved) : 0;
    }
    
    return 0;
  });
  
  // ✅ FIX: Only load saved answers if quiz was actually completed
  const [selectedAnswers, setSelectedAnswers] = useState(() => {
    const savedStatus = localStorage.getItem(`status_${accountId}_health-safety`);
    const isActuallyComplete = savedStatus === "complete";
    
    if (isActuallyComplete) {
      const saved = localStorage.getItem("healthsafety_selectedAnswers");
      if (saved) {
        try {
          const parsed = JSON.parse(saved);
          if (Array.isArray(parsed)) return parsed;
        } catch (e) {
          console.error("Error parsing saved answers", e);
        }
      }
    }
    
    // If not complete, start fresh
    return Array(quizQuestions.length).fill(null);
  });
  
  const [isCorrect, setIsCorrect] = useState(null);

  // state to track if user has already passed
  const [quizPassed, setQuizPassed] = useState(() => {
    const savedStatus = localStorage.getItem(`status_${accountId}_${itemId}`);
    return savedStatus === "complete";
  });

  // sidebar
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Status tracking
  useEffect(() => {
    const savedStatus = localStorage.getItem(`status_${accountId}_${itemId}`);
    
    // ✅ FIX: If it is ALREADY complete, ensure state reflects that and STOP.
    // This prevents the code below from calculating "in-progress" and overwriting the DB.
    if (savedStatus === "complete") {
        if (!quizPassed) {
            setQuizPassed(true);
        }
        return; 
    }
    
    const allModulesUnlocked = modules.every((mod) =>
      unlockedModules.includes(mod.id)
    );
    const quizCompleted = selectedAnswers.every((answer) => answer !== null);
    
    let status = "incomplete";
    if (quizPassed) {
        status = "complete";
    } else if (allModulesUnlocked && quizCompleted) {
        status = "complete";
    } else if (unlockedModules.length > 1 || quizStarted) {
        status = "in-progress";
    }

    // Only update if status has changed
    if (savedStatus !== status) {
      // Update localStorage
      localStorage.setItem(`status_${accountId}_${itemId}`, status);
      localStorage.setItem(
        `form_${accountId}_${itemId}`,
        JSON.stringify({
          unlockedModules,
          selectedAnswers,
          quizCompleted,
        })
      );

      // Sync status to backend for real-time updates (form data stays in localStorage)
      if (accountId && status !== "incomplete") {
        API.post(`/api/registration/${accountId}/status/${itemId}`, {
          status,
          formData: {} // Don't send form data, just status
        }).catch(err => console.error("Failed to sync status:", err));
      }
    }
  }, [unlockedModules, selectedAnswers, quizStarted, accountId, quizPassed]);

  // On mount, attempt to fetch server-side progress for this item so browsers that did not start
  // the training don't incorrectly show it as complete due to leftover localStorage.
  useEffect(() => {
    (async () => {
      if (!accountId) return;
      try {
        const resp = await API.get(`/api/registration/${accountId}/items/health-safety`);
        const progress = resp.data?.progress;
        if (progress && progress.state === 'complete') {
          setQuizPassed(true);
          setQuizStarted(false);
          // ✅ FIX: Don't auto-unlock all modules - let user navigate through them naturally
          // Only mark as complete, don't change the unlocked modules
          localStorage.setItem(`status_${accountId}_health-safety`, 'complete');
          localStorage.setItem(`form_${accountId}_${itemId}`, JSON.stringify({ quizCompleted: true }));
        }
      } catch (err) {
        // ignore — fallback to localStorage behavior
      }
    })();
  }, [accountId]);

  // ---------------- HELPER: UNLOCK MODULE ----------------
  const unlockModule = (id) => {
    setUnlockedModules((prev) => {
      if (!prev.includes(id)) {
        const updated = [...prev, id];
        localStorage.setItem("healthsafety_unlockedModules", JSON.stringify(updated));
        return updated;
      }
      return prev;
    });
  };

  // ---------------- HELPER: SET MODULE ----------------
  const setModule = (id) => {
    unlockModule(id);
    setCurrentModule(id);
    setQuizStarted(false);
    setIsCorrect(null);
  };

  // ---------------- LOAD PROGRESS ----------------
  // ✅ FIX: This useEffect is now redundant since we initialize state from localStorage
  // in useState() with completion checks. Removed to prevent overriding initialization.
  // The state is already initialized correctly based on completion status.
  
  // Keep this useEffect to save progress as user makes changes
  useEffect(() => {
    localStorage.setItem(
      "healthsafety_selectedAnswers",
      JSON.stringify(selectedAnswers)
    );
  }, [selectedAnswers]);

  useEffect(() => {
    localStorage.setItem("healthsafety_currentModule", currentModule);
  }, [currentModule]);

  useEffect(() => {
    localStorage.setItem("healthsafety_quizIndex", quizIndex);
  }, [quizIndex]);

  // ---------------- NAVIGATION ----------------
  const goNextModule = () => {
    const idx = modules.findIndex((m) => m.id === currentModule);
    if (idx < modules.length - 1) {
      const nextId = modules[idx + 1].id;
      unlockModule(nextId);
      setModule(nextId);
    }
  };

  const goBackModule = () => {
    const idx = modules.findIndex((m) => m.id === currentModule);
    if (idx > 0) setModule(modules[idx - 1].id);
  };

  const startQuiz = () => {
    setQuizStarted(true);
    setIsCorrect(null);
  };

  // ---------------- QUIZ HANDLERS ----------------
  const handleAnswerClick = (idx) => {
    setSelectedAnswers((prev) => {
      const newAnswers = [...prev];
      newAnswers[quizIndex] = idx;
      return newAnswers;
    });
    checkCorrectness(quizIndex, idx);
  };

  // const handleMatchingChange = (pairId, choice) => {
  //   setSelectedAnswers((prev) => {
  //     const newAnswers = [...prev];
  //     const current = newAnswers[quizIndex] || {};
  //     newAnswers[quizIndex] = { ...current, [pairId]: choice };
  //     return newAnswers;
  //   });

  //   const currentAnswers = {
  //     ...(selectedAnswers[quizIndex] || {}),
  //     [pairId]: choice,
  //   };
  //   checkCorrectness(quizIndex, currentAnswers);
  // };

  const checkCorrectness = (qIndex, answer) => {
    const q = quizQuestions[qIndex];
    if (q.type === "matching") {
      if (!answer || Object.keys(answer).length === 0) {
        setIsCorrect(null);
        return;
      }
      const correct = Object.keys(q.answer).every(
        (k) => answer && answer[k] === q.answer[k]
      );
      setIsCorrect(correct);
    } else {
      if (answer == null) {
        setIsCorrect(null);
      } else {
        setIsCorrect(answer === q.answer);
      }
    }
  };

  const nextQuestion = () => {
    if (quizIndex < quizQuestions.length - 1) {
      const nextIdx = quizIndex + 1;
      setQuizIndex(nextIdx);
      const nextAns = selectedAnswers[nextIdx];
      if (
        nextAns == null ||
        (typeof nextAns === "object" && Object.keys(nextAns).length === 0)
      ) {
        setIsCorrect(null);
      } else {
        checkCorrectness(nextIdx, nextAns);
      }
    }
  };

  const prevQuestion = () => {
    if (quizIndex > 0) {
      const prevIdx = quizIndex - 1;
      setQuizIndex(prevIdx);
      const prevAns = selectedAnswers[prevIdx];
      if (
        prevAns == null ||
        (typeof prevAns === "object" && Object.keys(prevAns).length === 0)
      ) {
        setIsCorrect(null);
      } else {
        checkCorrectness(prevIdx, prevAns);
      }
    }
  };

  const finishModule = () => {
    setQuizPassed(true); // Update state so UI reflects completion immediately
    
    // Mark all modules as unlocked when quiz is completed successfully
    const allIds = modules.map(m => m.id);
    setUnlockedModules(allIds);
    
    const payloadForm = {
      unlockedModules: allIds,
      selectedAnswers,
      quizCompleted: true
    };
    
    localStorage.setItem(`status_${accountId}_health-safety`, "complete");
    localStorage.setItem(`form_${accountId}_${itemId}`, JSON.stringify(payloadForm));
    localStorage.setItem('healthsafety_unlockedModules', JSON.stringify(allIds));
    
    // Trigger update and navigate
    window.dispatchEvent(new Event("storage"));
    showSuccess("Form completed successfully!");
    navigate('/register');
  };

  // ---------------- RENDER ----------------
  return (
    <div className="whmis-container">
      <div className="hamburger" onClick={() => setSidebarOpen(!sidebarOpen)}>
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
      </div>

      <aside className={`whmis-sidebar ${sidebarOpen ? "open" : ""}`}>
        {modules.map((mod) => {
          const isUnlocked = unlockedModules.includes(mod.id);
          return (
            <div
              key={mod.id}
              className={`sidebar-item ${
                currentModule === mod.id ? "active" : ""
              } ${isUnlocked ? "completed" : "locked"}`}
              onClick={() => {
                if (!isUnlocked) return;
                setModule(mod.id);
                setSidebarOpen(false);
              }}
            >
              {mod.id} - {mod.title} {isUnlocked && "✔️"}
            </div>
          );
        })}
      </aside>

      <main className="whmis-section">
        <h2>{modules.find((m) => m.id === currentModule)?.title}</h2>

        {currentModule !== "09" && baseContent[currentModule]}

        {currentModule === "09" && (
          <div className="quiz-container">
            {!quizStarted ? (
              <div>
                <p>Please complete the Health and Safety Questionnaire</p>
                {quizPassed ? (
                  <button
                    className="whmis-btn"
                    onClick={() => navigate('/register')}
                  >
                    ✅ COMPLETED
                  </button>
                ) : (
                  <button
                    className="whmis-btn start-quiz-btn"
                    onClick={startQuiz}
                  >
                    Start Quiz
                  </button>
                )}
              </div>
            ) : (
              <div>
                {quizQuestions[quizIndex] ? (
                  <>
                    <p>{quizQuestions[quizIndex].question}</p>
                    <div className="quiz-options-list">
                      {quizQuestions[quizIndex].options.map((opt, idx) => (
                    <label key={idx} className="quiz-option">
                      <input
                        type="checkbox"
                        checked={selectedAnswers[quizIndex] === idx}
                        onChange={() => handleAnswerClick(idx)}
                      />
                      {opt}
                    </label>
                  ))}
                </div>

                {isCorrect === false && (
                  <p className="feedback wrong">❌ Wrong answer, try again!</p>
                )}

                {isCorrect === true && (
                  <p className="feedback correct">
                    {quizIndex === quizQuestions.length - 1
                      ? "✅ Correct! Click COMPLETE to finish."
                      : "✅ Correct! Click NEXT to continue."}
                  </p>
                )}

                <div className="quiz-buttons">
                  <button
                    className="whmis-btn"
                    onClick={prevQuestion}
                    disabled={quizIndex === 0}
                  >
                    BACK
                  </button>

                  {quizIndex === quizQuestions.length - 1 ? (
                    <button
                      className="whmis-btn"
                      onClick={finishModule}
                      disabled={!isCorrect}
                    >
                      COMPLETE
                    </button>
                  ) : (
                    <button
                      className="whmis-btn"
                      onClick={nextQuestion}
                      disabled={!isCorrect}
                    >
                      NEXT
                    </button>
                  )}
                </div>
                  </>
                ) : (
                  <div className="quiz-error">
                    <p>Quiz data not available. Please refresh the page.</p>
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        <div style={{ height: "50px" }}></div>

        {currentModule !== "09" && (
          <div className="whmis-buttons">
            {/* in-content nav retained if needed */}
          </div>
        )}
        {/* Sticky bottom navigation: match WHMIS behaviour */}
        <div className="whmis-nav-container">
          <div className="nav-left-group">
            <button
              type="button"
              className="whmis-back-btn"
              onClick={goBackModule}
            >
              BACK
            </button>
            
            {currentModule === "09" ? (
              <button
                type="button"
                className="whmis-submit-btn pl-2"
                onClick={() => navigate("/register")}
              >
                CLOSE
              </button>
            ) : (
              <button
                type="button"
                className="whmis-submit-btn"
                onClick={goNextModule}
              >
                NEXT
              </button>
            )}
          </div>
          <button
            type="button"
            className="bg-gray-200 border border-gray-400 text-gray-700 px-4 py-2 rounded hover:bg-gray-300 whmis-nav-right"
            onClick={() => navigate("/register")}
          >
            EXIT
          </button>
        </div>
      </main>
    </div>
  );
}
